import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-col items-center mb-8">
        <img 
          src="https://www.2kbundesliga.de/wp-content/uploads/2022/01/cropped-cropped-2kbuli-header_06.png" 
          alt="2K Bundesliga Logo"
          className="h-24 md:h-32 w-auto object-contain mb-4"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        <h1 className="text-4xl font-bold">{t('about.title')}</h1>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-8 mb-6">
        <h2 className="text-2xl font-bold mb-4 text-nba-blue">{t('about.mission')}</h2>
        <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
          {t('about.missionText1')}
        </p>
        <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
          {t('about.missionText2')}
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-8 mb-6">
        <h2 className="text-2xl font-bold mb-4 text-nba-blue">{t('about.leagueStructure')}</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-xl font-semibold mb-3">{t('about.easternConference')}</h3>
            <p className="text-gray-700 dark:text-gray-300">
              {t('about.easternDesc')}
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-3">{t('about.westernConference')}</h3>
            <p className="text-gray-700 dark:text-gray-300">
              {t('about.westernDesc')}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-8 mb-6">
        <h2 className="text-2xl font-bold mb-4 text-nba-blue">{t('about.whatMakesUsDifferent')}</h2>
        <div className="space-y-4">
          <div className="flex items-start">
            <div className="bg-nba-blue text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1 mr-3">
              1
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-1">{t('about.crossPlatformPlay')}</h3>
              <p className="text-gray-700 dark:text-gray-300">
                {t('about.crossPlatformDesc')}
              </p>
            </div>
          </div>

          <div className="flex items-start">
            <div className="bg-nba-blue text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1 mr-3">
              2
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-1">{t('about.authenticExperience')}</h3>
              <p className="text-gray-700 dark:text-gray-300">
                {t('about.authenticDesc')}
              </p>
            </div>
          </div>

          <div className="flex items-start">
            <div className="bg-nba-blue text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1 mr-3">
              3
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-1">{t('about.statsTracking')}</h3>
              <p className="text-gray-700 dark:text-gray-300">
                {t('about.statsDesc')}
              </p>
            </div>
          </div>

          <div className="flex items-start">
            <div className="bg-nba-blue text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1 mr-3">
              4
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-1">{t('about.multipleSeasons')}</h3>
              <p className="text-gray-700 dark:text-gray-300">
                {t('about.multipleSeasonsDesc')}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-nba-blue to-nba-red text-white rounded-lg shadow-lg dark:shadow-gray-900 p-8">
        <h2 className="text-2xl font-bold mb-4">{t('about.joinOurLeague')}</h2>
        <p className="mb-6 text-lg">
          {t('about.joinDescription')}
        </p>
        <div className="flex flex-wrap gap-4">
          <div className="bg-white dark:bg-gray-800 bg-opacity-20 rounded-lg px-6 py-3">
            <div className="font-bold text-2xl">30</div>
            <div className="text-sm">{t('about.nbaTeamsCount')}</div>
          </div>
          <div className="bg-white dark:bg-gray-800 bg-opacity-20 rounded-lg px-6 py-3">
            <div className="font-bold text-2xl">58</div>
            <div className="text-sm">{t('about.gamesPerSeason')}</div>
          </div>
          <div className="bg-white dark:bg-gray-800 bg-opacity-20 rounded-lg px-6 py-3">
            <div className="font-bold text-2xl">2-3</div>
            <div className="text-sm">{t('about.seasonsPerYear')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
